import { userSlice } from "@/redux/User";
import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { State } from "@/redux/Types";

export default function useGetCompanyUser() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: State) => state.user.isLoggedIn);

  return useQuery({
    queryKey: ["getCompanyUser"],
    enabled: isLoggedIn,
    queryFn: async () => {
      const response = await axiosGet(`users/getCompanyUser`);
      const user = response.data.user;
      dispatch(userSlice.actions.setRole(user?.role ?? user));
      return user;
    },
  });
}
